import AppImage from '@theme/components/atom/AppImage'
import MenuItemMixin from '~/mixins/MenuItemMixin'
import Pill from '@theme/components/atom/Pill'
import VerticalMenuItem from '~/themes/base/components/shop/VerticalMenuItem'

export default {
  components: { AppImage, Pill },
  extends: VerticalMenuItem,
  mixins: [MenuItemMixin],
}
